/* eslint-disable */
export type CastleDefenseProvider = 'JAM'|'GAMEDAY';

export const CastleDefenseProviders = {
  JAM: 'JAM',
  GAMEDAY: 'GAMEDAY',
};
